import { createAsyncStore } from "common/axios/asyncModel";
import { UserRepository } from "repository/userRepository";
import { saveUserInfo, clearAll, UserInfo } from "common/utils/secureStorage";

const ssoLogin = createAsyncStore();
const ssoSignup = createAsyncStore();
const ssoUser = createAsyncStore();

// SSO 로그인
const onSsoLogin = (params: { email: string; password: string; deviceId?: string; os?: string }) => {
    ssoLogin.onGetAll(() => UserRepository.onSsoLogin(params));
}

// SSO 회원가입
const onSsoSignup = (params: { email: string; password: string; nickname: string; deviceId?: string; os?: string }) => {
    ssoSignup.onGetAll(() => UserRepository.onSsoSignup(params));
}

// SSO 회원정보 조회
const onGetSsoUser = () => {
    const accessToken = sessionStorage.getItem('accessToken');
    if (accessToken) {
        ssoUser.onGetAll(() => UserRepository.onGetSsoUser(accessToken));
    }
}

// 회원정보 저장 (암호화) - wiz-sso UserResponse 기반
const onSaveUserInfo = (data: any) => {
    const userInfo: UserInfo = {
        userId: data.userId || '',           // SSO에서 암호화되어 옴
        nickname: data.nickName || '',       // 닉네임
        ctn: data.ctn || '',                 // 본인 연락처
        age: data.age || '',                 // 생년월일/나이
        profileImgPath: data.profileImgPath || '',
        profileImgNo: data.profileImgNo || '',
        isMinor: data.isMinor || 'N',
        guardCtn: data.guardCtn || '',       // 보호자 연락처
        locale: data.locale || 'ko',
        distanceUnit: data.distanceUnit || 'km'
    };
    saveUserInfo(userInfo);
}

// 로그아웃
const onLogout = () => {
    const accessToken = sessionStorage.getItem('accessToken');
    if (accessToken) {
        UserRepository.onSsoLogout(accessToken);
    }
    // 모든 인증 정보 삭제 (암호화된 사용자 정보 포함)
    clearAll();
}

// 토큰 유효성 검사
const isAuthenticated = () => {
    const accessToken = sessionStorage.getItem('accessToken');
    return !!accessToken;
}

export const userStore = {
    ssoLogin,
    ssoSignup,
    ssoUser,
    onSsoLogin,
    onSsoSignup,
    onGetSsoUser,
    onSaveUserInfo,
    onLogout,
    isAuthenticated
}